var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"variant":"warning"}},[_vm._v(_vm._s(_vm.$t('you are already logged in')))])}
var staticRenderFns = []

export { render, staticRenderFns }